import { render, staticRenderFns } from "./ListGroupCompany.vue?vue&type=template&id=8b91137c&"
import script from "./ListGroupCompany.vue?vue&type=script&lang=js&"
export * from "./ListGroupCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports